import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import MultiLevelSelectTypeahead from '../MultiLevelSelectTypeahead';
import { decorateCategoriesList } from './config';
import { isUnified } from '../../utils/helpers';

const emptyState = (
  <div className="py-sm d-flex align-items-center justify-content-center">
    <p className="text-black">No categories found with this criteria</p>
  </div>
);

const CategoriesSingleSelect = ({
  store,
  onChange,
  categories,
  multi,
  style,
  className,
  showTypeahead,
  excludeOverall,
  includeAllCategories,
  enableUmbrellaCategories,
  dropdownHeight,
  dropdownPosition,
  nestedGroupPosition,
  withStoreIcon,
  keepOpen,
  disabled,
  showAsDropdown,
  gamesNonGames,
  overallCategoryCustomName,
  excludedCategories,
  withAllNonGamesVirtualCategory,
}) => {
  const setters = {
    store,
    excludeOverall,
    enableUmbrellaCategories,
    gamesNonGames,
    overallCategoryCustomName,
    excludedCategories,
    includeAllCategories,
    withAllNonGamesVirtualCategory,
  };

  const dataset = decorateCategoriesList(setters);

  return (
    <div className={cx(className, { 'without-typeahead': !showTypeahead })} style={style}>
      <MultiLevelSelectTypeahead
        selectId="categories"
        placeholder="Select category"
        multi={multi}
        withStoreIcon={withStoreIcon || (multi && isUnified(store))}
        emptyState={emptyState}
        childrenContainerWidth="100%"
        dropdownHeight={dropdownHeight}
        dropdownPosition={dropdownPosition}
        nestedGroupPosition={nestedGroupPosition}
        keepOpen={keepOpen}
        disabled={disabled}
        showAsDropdown={showAsDropdown && !isUnified(store)}
        dataset={dataset}
        selection={categories}
        onChange={onChange}
      />
    </div>
  );
};

CategoriesSingleSelect.propTypes = {
  store: T.string.isRequired,
  onChange: T.func.isRequired,
  categories: T.array.isRequired,
  multi: T.bool,
  style: T.object,
  className: T.string,
  showTypeahead: T.bool,
  excludeOverall: T.bool,
  includeAllCategories: T.bool,
  enableUmbrellaCategories: T.bool,
  dropdownHeight: T.string,
  dropdownPosition: T.oneOf(['auto', 'top', 'bottom']),
  nestedGroupPosition: T.oneOf(['left', 'right']),
  withStoreIcon: T.bool,
  keepOpen: T.bool,
  disabled: T.bool,
  showAsDropdown: T.bool,
  gamesNonGames: T.oneOf(['games', 'non_games', 'all_apps', '']),
  overallCategoryCustomName: T.string,
  excludedCategories: T.array, // [36001000, 36001001, 36001002, 36001003]
  withAllNonGamesVirtualCategory: T.bool,
};

CategoriesSingleSelect.defaultProps = {
  showTypeahead: true,
  excludeOverall: false,
  includeAllCategories: false,
  dropdownPosition: 'auto',
  nestedGroupPosition: 'right',
  enableUmbrellaCategories: false,
  withStoreIcon: false,
  keepOpen: false,
  disabled: false,
  showAsDropdown: false,
  gamesNonGames: 'all_apps',
  overallCategoryCustomName: null,
  excludedCategories: [],
  withAllNonGamesVirtualCategory: false,
};

export default CategoriesSingleSelect;
